import React, { useEffect, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Event404 from '@src/mobile/components/Page404';
import { hexToRgba } from '@src/public/utils';
import PropTypes from 'prop-types';
import styles from './index.css';
import { ListStore } from '../store';

const Wrap = ({ children }) => {
    const listStore = ListStore.useContainer();
    const { listStates } = listStore;
    const { pcBgInfo, online } = listStates;

    const [bgImg, setBgImg] = useState('');
    const [startTransColor, setStartTransColor] = useState('');
    const [endTransColor, setEndTransColor] = useState('');
    const [showFade, setShowFade] = useState(false);

    useEffect(
        () => {
            if (pcBgInfo) {
                const { pcBgColor, pcBgShowFade, pcBgImg } = pcBgInfo;

                document.body.style.backgroundColor = pcBgColor;

                setStartTransColor(hexToRgba(pcBgColor, 1));
                setEndTransColor(hexToRgba(pcBgColor, 0));
                setBgImg(pcBgImg);
                setShowFade(pcBgShowFade);
            }
        },
        [pcBgInfo],
    );

    return (
        <>
            {online ? (
                <>
                    {pcBgInfo ? (
                        <div className={styles.bgImage} style={{ backgroundImage: `url(${bgImg})` }}>
                            {showFade ? (
                                <div
                                    className={styles.transColor}
                                    style={{
                                        backgroundImage: `linear-gradient(to top, ${startTransColor} , ${endTransColor})`,
                                    }}
                                />
                            ) : null}
                        </div>
                    ) : null}
                    <div className={styles.wrap}>{children}</div>
                </>
            ) : (
                <Event404 text={'服务器开小差了'} />
            )}
        </>
    );
};

Wrap.propTypes = {
    children: PropTypes.any,
};

export default errorBoundary(Wrap);
